import Vue from 'vue'

const initialState = {
  governmentAgencies: [],
  counterparts: [],
  senders: [],
  departments: [],
  correspondents: [],
  registerBooks: [],
  searchResults: {
    documents: [],
    assignments: [],
    employees: []
  },
  loading: false
}

export default {
  namespaced: true,
  state: {
    ...initialState
  },
  mutations: {
    SET(state, data) {
      state[data.key] = data.val
    },
    CLEAR(state, key = false) {
      if (key)
        state[key] = initialState[key]
      else state = {...initialState}
    }
  },
  actions: {
    getGovernmentAgencies({commit}, query) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/government_agencies/?q=${query}`, {__silent: true}).then(response => {
          commit('SET', {key: 'governmentAgencies', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getCounterparts({commit}, query) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/counterparts/?q=${query}`, {__silent: true}).then(response => {
          commit('SET', {key: 'counterparts', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDocuments({commit}, query) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/documents/search/?q=${query}`, {__silent: true}).then(response => {
          commit('SET', {key: 'counterparts', val: response.data})
          resolve(response.data.results)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getCorrespondents({commit}, {searchQuery, scope, canAddExternal}) {
      return new Promise((resolve, reject) => {
        let params
        if (scope === 'planExecutors') {
          params = '&organizations=true&departments=true&employees=true&externals=true&organization_groups=true'
        } else if (scope === 'employees') {
          params = '&organizations=false&departments=false&employees=true&externals=false&organization_groups=false'
        } else if (scope === 'all') {
          params = '&organizations=true&departments=true&employees=true&externals=true&organization_groups=true'
        } else if (scope === 'correspondent') {
          params = '&organizations=true&departments=true&employees=true&externals=true&organization_groups=true'
        } else if (scope === 'systemObjects') {
          params = '&organizations=true&departments=true&employees=true&externals=false&organization_groups=false'
        } else if (scope === 'systemObjectsAndOrganizationGroups') {
          params = '&organizations=true&departments=true&employees=true&externals=false&organization_groups=true'
        } else {
          params = '&organizations=true&departments=true&employees=true&externals=true&organization_groups=false'
        }
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/correspondents/search/?q=${searchQuery}${params}`, {__silent: true}).then(response => {
          let data = [];
          if (!['employees', 'systemObjectsAndOrganizationGroups'].includes(scope) && canAddExternal) {
            data = [
              {name: searchQuery, type: 'new'},
              ...response.data
            ]
          } else {
            data = response.data
          }
          commit('SET', {
            key: 'correspondents', val: data
          })
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getDepartments({commit}, query = null) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`reference/departments/`, {
          __silent: true,
          props: query ? {q: query} : {}
        }).then(response => {
          commit('SET', {key: 'departments', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getSenders({commit}, query) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/senders/search/?q=${query}`, {
          __silent: true
        }).then(response => {
          commit('SET', {key: 'senders', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    getRegisterBooks({commit}) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`docflow/register_books/`, {
          __silent: true
        }).then(response => {
          commit('SET', {key: 'registerBooks', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    },
    globalSearch({commit}, q) {
      return new Promise((resolve, reject) => {
        commit('SET', {key: 'loading', val: false})
        Vue.axios.get(`fts/search/`, {params: {q}}).then(response => {
          commit('SET', {key: 'searchResults', val: response.data})
          resolve(response.data)
        }).catch(error => reject(error)).finally(() => {
          commit('SET', {key: 'loading', val: false})
        })
      })
    }
  }
}
